import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { HttpClient } from "src/infra/http/client";
import { DacadooEndpoints } from "src/containers/dacadoo/constants/endpoints";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class DacadooRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    get userIdentity(): string {
        return window.userIdentity;
    }

    @autoBind
    isClient(): Observable<boolean> {
        const url = DacadooEndpoints.IsClient;
        return this.http.getJSON<boolean>(url, {
            host: this.http.msHostEnv,
            isPublicRequest: false,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(
                    this.userIdentity,
                    "MEP"
                ),
            },
        });
    }
}
